import React from "react"
import { TableSeekerContextProvider } from 'ui-seeker/core'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})
// isRecalculating: an exclusion toggle is refetching the figures; the rows stay on screen and the compset row pulses
const initialState = { tableData: [], isLoading: true, isRecalculating: false, dates: [], mainHotelIds: [], idMainHotel: null }

export function CompetitionAnalyzerCompetitionDailyTableProvider({children}) {
	const { state, updateState } = useAppContextState(initialState)

	return <Context.Provider value={{state, updateState}}>
		<TableSeekerContextProvider>
			{children}
		</TableSeekerContextProvider>
	</Context.Provider>
}

export default Context